(() => {
  const select = document.querySelector('[data-synergy-variant-select]');
  const handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  if (!select || !handle) return;

  // Normalize an image URL to its base filename so sizes/versions still match
  const fileKey = src => src.split('?')[0].split('/').pop().toLowerCase()
    .replace(/\.(jpe?g|png|gif|webp|avif)$/, '')
    .replace(/_(\d+x\d*|\d*x\d+)(_crop_\w+)?(@\dx)?$/, '');

  const variantImages = {};
  fetch(`/products/${handle}.js`)
    .then(r => r.json())
    .then(p => p.variants.forEach(v => {
      if (v.featured_image) variantImages[v.id] = fileKey(v.featured_image.src);
    }));

  function showVariantImage() {
    const key = variantImages[select.value];
    if (!key) return;
    const imgs = [...document.querySelectorAll('img')].filter(img => {
      const s = img.currentSrc || img.src || img.dataset.src || '';
      return s && fileKey(s) === key;
    });
    for (const img of imgs) {
      const thumb = img.closest('[class*="thumb"], [data-gallery-thumbnail], button');
      if (thumb) { thumb.click(); return; }
    }
    console.warn('Variant image fix: no matching thumbnail for variant', select.value);
  }

  // The synergy buttons change the value silently, so check after every click
  let last = select.value;
  document.addEventListener('click', () => {
    setTimeout(() => {
      if (select.value !== last) { last = select.value; showVariantImage(); }
    }, 50);
  });
  select.addEventListener('change', () => { last = select.value; showVariantImage(); });
})();